export default __webpack_public_path__ + "static/media/loading.525b5cce.gif";